<template>
  <div class="col">
    <div class="row">
      <div class="col mt-2 mb-2">
        <label class="float-left">
          <span class="upload-button">{{ $t("validator.selectFile") }}</span>
          <input :ref="'files'" type="file" @input="selectFile" />
          <span v-if="file" class="text-tertiary">: {{ file.name }}</span>
        </label>

      </div>
        <div class="float-left text-tertiary">
          {{ $t("validator.filetype")}}:
          <input class="ml-2" type="radio" v-model="filetype" id="finvoice" value="finvoice" />
          <label for="finvoice">Finvoice</label>
          <input class="ml-2" type="radio" v-model="filetype" id="teapps" value="teapps" />
          <label for="teapps">TEAPPS</label>
        </div>
      <div class="col pr-0">
        <button
          :disabled="!file || loading"
          @click="upload"
          class="btn btn-success float-right"
          style="min-width:13em;"
        >
          <template v-if="!loading">{{ $t("validator.validateFile") }}</template>
          <template v-else>
            <div class="spinner-border spinner-border-sm"></div>
          </template>
        </button>
      </div>
    </div>
    <div class="row">
      <textarea class="form-control" ref="outputField" style="width:100%;min-height:600px" v-model="output"></textarea>
    </div>
    <div class="row">
      <button
        :disabled="!output"
        @click="copyToClipboard"
        class="btn btn-success-lower ml-auto mt-2"
        style="min-width:13em;"
      >{{ $t("validator.copyToClipboard") }}</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      file: null,
      output: "",
      loading: false,
      filetype: "finvoice",
      publicPath: process.env.BASE_URL
    };
  },
  methods: {
    selectFile: function(e) {
      if (e.target.files) {
        this.file = e.target.files[0];
      } else {
        this.file = null;
        this.$refs.files.value = "";
      }
    },
    upload: async function(e) {
      try {
        if (this.file) {
          let file = this.file;

          this.loading = true;
          let formData = new FormData();
          formData.append("file", file);
          formData.append(
            "filetype",
            this.filetype
          );

          let res = await this.$store.dispatch("validateXML", formData);
          this.output = res.data;
        }
        this.$refs.files.value = "";
      } catch (error) {
        console.log(error);
        this.$notify({
          type: "error",
          text: this.$t("validator.operationFailed"),
          duration: 3000
        });
      } finally {
        this.loading = false;
      }
    },
    copyToClipboard: function() {
      const copyText = this.$refs.outputField;
      copyText.select();
      copyText.setSelectionRange(0, 99999); /*For mobile devices*/

      /* Copy the text inside the text field */
      document.execCommand("copy");
      this.$notify({
        type: "success",
        text: this.$t("validator.copied"),
        duration: 3000
      });

      /* Alert the copied text */
    }
  }
};
</script>

<style scoped>
.validator-importer {
  border-right: 2px dashed #086A91;
  margin-top: 10px;
  padding: 0 10px;
  max-width: 1000px;
}
input[type="file"] {
  display: none;
}
.upload-button {
  color: #444356;
  cursor: pointer;
  text-decoration: underline;
}
input[type="radio"] {
  accent-color: #006366;
}
.upload-button:hover {
  text-decoration: underline;
}
.validator-importer-instructions > p {
  margin-bottom: 0.5rem;
}
.form-control:focus {
  border: 1px solid #086A91;
  box-shadow: 0 0 5px #086A91;
}
@media screen and (max-width: 950px) {
  .validator-importer {
    border-left: none;
    margin-top: 0;
    padding: 10px;
  }
}
</style>
